(() => {
  const init = (root) => {
    if (!root || root.dataset.gbReady) return;
    root.dataset.gbReady = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    root.querySelectorAll('.gb-reveal').forEach((item) => observer.observe(item));
    if (reduced) return;
    const hero = root.querySelector('[data-gb-hero]');
    const origin = root.querySelector('[data-gb-parallax]');
    const spin = root.querySelector('[data-gb-spin]');
    const spinner = root.querySelector('[data-gb-spin-object]');
    const closing = root.querySelector('.gb-closing');
    let ticking = false;
    const render = () => {
      const vh = innerHeight;
      if (hero) hero.style.setProperty('--gb-hero-y', `${Math.min(scrollY * .16, 150)}px`);
      if (origin) { const r = origin.getBoundingClientRect(); origin.style.setProperty('--gb-origin-y', `${Math.max(-12, Math.min(2, (vh - r.top) / (vh + r.height) * 14 - 12))}%`); }
      if (spin && spinner) { const r = spin.getBoundingClientRect(); const p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height))); spinner.style.setProperty('--gb-spin', `${p * 360 - 80}deg`); spinner.style.setProperty('--gb-tilt', `${p * 8 - 7}deg`); }
      if (closing) { const r = closing.getBoundingClientRect(); const p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height))); closing.style.setProperty('--gb-close-y', `${-11 + p * 11}%`); }
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(render); ticking = true; } }, { passive:true });
    render();
  };
  document.querySelectorAll('[data-ganbaru-home]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-ganbaru-home]')));
})();
